import Vue from "vue"

const state = () => ({
    hints: {}
})

const getters = {
    hints: state => state.hints,
}

const mutations = {
    updateHint(state, data) {
        //console.log("hints: " + JSON.stringify(state.hints));

        var nextHint = {};

        if (state.hints[data.id]){
            nextHint = state.hints[data.id];
        }
        else{
            nextHint.id = data.id;
            nextHint.text = "";
            nextHint.blue = true;
        }

        if (data.isStart){
            nextHint.startId = data.elementId;
        }
        else{
            nextHint.endId = data.elementId;
        }

        if (nextHint.startId && nextHint.endId){
            nextHint.show = true;
        }

        //console.log(JSON.stringify(nextHint))
        Vue.set(state.hints, data.id, nextHint);
    },

    exitHint(state, data) {
        if (state.hints[data.id] !== null){
            var updatedHint = state.hints[data.id];
            updatedHint.show = false;
            updatedHint.startId = null;
            updatedHint.endId = null;
            Vue.set(state.hints, data.id, updatedHint);
        }
    },

    removeHint(state, data) {
        if (state.hints[data.id] !== null){
            Vue.delete(state.hints, data.id);
        }
    },
}

const actions = {
    updateHint ({commit, state}, data) {
        commit('updateHint', data)
    },

    exitHint ({commit, state}, data) {
        commit('exitHint', data)
    },

    removeHint ({commit, state}, data) {
        commit('removeHint', data)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
